import React from 'react';
import {
	List,
	Filter,
	TextInput,
	Datagrid,
	TextField,
	FunctionField,
} from 'react-admin';
import ConfirmDeleteButton from '../../Components/Button/ConfirmDeleteBtn';

const OverrideFilter = (props: any) => (
	<Filter {...props}>
		<TextInput label="Search" source="q" alwaysOn />
	</Filter>
);

const formatDate = (dateString: string | null) => {
	if (!dateString) return 'Permanent';
	return new Date(dateString).toLocaleDateString('fr-FR');
};

const reasonColors: Record<string, string> = {
	promo: '#4caf50',
	admin: '#2196f3',
	migration: '#ff9800',
};

export const OverrideList = (props: any) => (
	<List {...props} filters={<OverrideFilter />} exporter={false}>
		<Datagrid rowClick={(id) => `${id}`}>
			<TextField source="id" />
			<FunctionField
				label="Billing Account"
				render={(record: any) => record.billingAccount?.name || record.billingAccountId}
			/>
			<FunctionField
				label="Feature"
				render={(record: any) => record.feature?.name || record.featureId}
			/>
			<TextField source="value" />
			<FunctionField
				label="Reason"
				render={(record: any) => (
					<span style={{ color: reasonColors[record.reason] || '#000', fontWeight: 600 }}>
						{record.reason}
					</span>
				)}
			/>
			<FunctionField
				label="Expires"
				render={(record: any) => formatDate(record.expiresAt)}
			/>
			<TextField source="createdBy" label="Created By" />
			<FunctionField
				render={(record: any) => (
					<ConfirmDeleteButton
						record={record}
						title="Delete override"
						entity="entitlement-overrides"
						description="Are you sure to delete this override?"
						confirmMessage="Override deleted"
					/>
				)}
			/>
		</Datagrid>
	</List>
);
